"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.action = action;
exports.attachments = attachments;
exports.attachmentsByEmail = attachmentsByEmail;
exports.batchAction = batchAction;
exports.blockDomain = blockDomain;
exports.create = create;
exports.endpoints = void 0;
exports.fetchSuggestedBlocks = fetchSuggestedBlocks;
exports.list = list;
exports.pendingMessage = pendingMessage;
exports.pendingThreads = pendingThreads;
exports.remove = remove;
exports.suggestions = suggestions;
exports.threadList = threadList;
exports.threadListByEmail = threadListByEmail;
exports.unblockDomain = unblockDomain;
exports.update = update;
exports.updateSuggestedBlock = updateSuggestedBlock;
exports.uploadAvatar = uploadAvatar;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _moment = _interopRequireDefault(require("moment"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _get = _interopRequireDefault(require("lodash/get"));
var _requests = require("@edison/requests");
var _functools = require("@edison/functools");
var _utils = require("./utils");
var _constants = require("../utils/constants");
var _excluded = ["insertTime"],
  _excluded2 = ["messages"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var endpoints = exports.endpoints = {
  list: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/contact/all");
    }
  },
  create: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/contact");
    }
  },
  update: {
    method: 'PUT',
    url: function url(contactId) {
      return "/".concat(_constants.API_V1, "/contact/").concat(contactId);
    }
  },
  "delete": {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/contact/delete");
    }
  },
  threadList: {
    method: 'GET',
    url: function url(contactId) {
      return "/".concat(_constants.API_V1, "/contact/").concat(contactId, "/thread");
    }
  },
  threadListByEmail: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/contact/email/thread");
    }
  },
  pendingThreads: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/contact/email/pendings");
    }
  },
  suggestions: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/contact/compose/suggestions");
    }
  },
  attachments: {
    method: 'GET',
    url: function url(contactId) {
      return "/".concat(_constants.API_V1, "/contact/").concat(contactId, "/attachment");
    }
  },
  attachmentsByEmail: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/search/attachment");
    }
  },
  uploadAvatar: {
    method: 'POST',
    url: function url(contactId) {
      return "/".concat(_constants.API_V1, "/contact/").concat(contactId, "/avatar");
    }
  },
  action: {
    method: 'PUT',
    url: function url(action) {
      return "/".concat(_constants.API_V1, "/contact/email/").concat(action);
    }
  },
  suggestedBlocks: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/sug_block/list");
    }
  },
  suggestedBlockAction: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/sug_block/update");
    }
  },
  pendingMessage: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/contact/email/pending_list");
    }
  },
  block: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/contact/domain/block");
    }
  },
  unblock: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/contact/domain/unblock");
    }
  }
};
function list(_x, _x2) {
  return _list.apply(this, arguments);
}
function _list() {
  _list = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref, rest) {
    var auth, status, includeDomains, optionals, _endpoints$list, method, url, res, contacts;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          auth = _ref.auth, status = _ref.status, includeDomains = _ref.includeDomains;
          optionals = (0, _functools.compose)((0, _requests.withParams)({
            status: status,
            includeDomains: includeDomains ? 1 : 0
          }), (0, _utils.withAuth)(auth), (0, _utils.withOptionals)(rest))(_objectSpread(_objectSpread({}, _utils.defaultOptionals), {}, {
            paramsFormat: _objectSpread(_objectSpread({}, _utils.defaultOptionals.paramsFormat), {}, {
              snakify: false
            })
          }));
          _endpoints$list = endpoints.list, method = _endpoints$list.method, url = _endpoints$list.url;
          _context.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context.sent;
          contacts = (0, _get["default"])(res, 'result.contacts', []);
          return _context.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
            result: {
              contacts: contacts.map(function (_ref17) {
                var insertTime = _ref17.insertTime,
                  rest = (0, _objectWithoutProperties2["default"])(_ref17, _excluded);
                return _objectSpread(_objectSpread({}, rest), {}, {
                  insertTime: _moment["default"].isMoment(insertTime) ? insertTime.unix() : insertTime
                });
              })
            }
          }));
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _list.apply(this, arguments);
}
function create(_x3) {
  return _create.apply(this, arguments);
}
function _create() {
  _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2) {
    var auth, contact, optionals, _endpoints$create, method, url, res;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          auth = _ref2.auth, contact = _ref2.contact;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
            contact: contact
          }))(_utils.defaultOptionals);
          _endpoints$create = endpoints.create, method = _endpoints$create.method, url = _endpoints$create.url;
          _context2.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context2.sent;
          return _context2.abrupt("return", res);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _create.apply(this, arguments);
}
function update(_x4) {
  return _update.apply(this, arguments);
}
function _update() {
  _update = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref3) {
    var auth, contact, optionals, _endpoints$update, method, url, res;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          auth = _ref3.auth, contact = _ref3.contact;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
            contact: contact
          }))(_utils.defaultOptionals);
          _endpoints$update = endpoints.update, method = _endpoints$update.method, url = _endpoints$update.url;
          _context3.next = 5;
          return (0, _requests.request)(url(contact.id), method, optionals);
        case 5:
          res = _context3.sent;
          return _context3.abrupt("return", res);
        case 7:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _update.apply(this, arguments);
}
function remove(_x5) {
  return _remove.apply(this, arguments);
}
/**
 * Returns the thread list for sepcified contact
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @param {string} contactId - Unique contact ID
 * @returns {Promise<ContactThreadListResponse>}
 */
function _remove() {
  _remove = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref4) {
    var auth, ids, optionals, _endpoints$delete, method, url, res;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          auth = _ref4.auth, ids = _ref4.ids;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
            ids: ids
          }))(_utils.defaultOptionals);
          _endpoints$delete = endpoints["delete"], method = _endpoints$delete.method, url = _endpoints$delete.url;
          _context4.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context4.sent;
          return _context4.abrupt("return", res);
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _remove.apply(this, arguments);
}
function threadList(_x6, _x7) {
  return _threadList.apply(this, arguments);
}
/**
 * Returns the thread list for sepcified contact by email address
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @param {string} pageToken - Page token
 * @param {string} pageSize - Page size
 * @param {string} email - Email address for the target contact
 * @returns {Promise<ContactThreadListResponse>}
 */
function _threadList() {
  _threadList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(contactId, _ref5) {
    var auth,
      pageToken,
      optionals,
      _endpoints$threadList,
      method,
      url,
      res,
      _args5 = arguments;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          auth = _ref5.auth;
          pageToken = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : '';
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
            pageToken: pageToken
          }))(_utils.defaultOptionals);
          _endpoints$threadList = endpoints.threadList, method = _endpoints$threadList.method, url = _endpoints$threadList.url;
          _context5.next = 6;
          return (0, _requests.request)(url(contactId), method, optionals);
        case 6:
          res = _context5.sent;
          return _context5.abrupt("return", res);
        case 8:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _threadList.apply(this, arguments);
}
function threadListByEmail(_x8, _x9) {
  return _threadListByEmail.apply(this, arguments);
}
function _threadListByEmail() {
  _threadListByEmail = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(email, _ref6) {
    var auth, pageToken, pageSize, optionals, _endpoints$threadList2, method, url, res;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          auth = _ref6.auth, pageToken = _ref6.pageToken, pageSize = _ref6.pageSize;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
            email: email,
            page_oken: pageToken,
            page_size: pageSize
          }))(_utils.defaultOptionals);
          _endpoints$threadList2 = endpoints.threadListByEmail, method = _endpoints$threadList2.method, url = _endpoints$threadList2.url;
          _context6.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context6.sent;
          return _context6.abrupt("return", res);
        case 7:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _threadListByEmail.apply(this, arguments);
}
/**
 * Returns the pending thread list for pending contact
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @param {string} email - Email address of pending contact
 * @returns {Promise<ContactThreadListResponse>}
 */
function pendingThreads(_x10, _x11) {
  return _pendingThreads.apply(this, arguments);
}
function _pendingThreads() {
  _pendingThreads = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(email, _ref7) {
    var auth, optionals, _endpoints$pendingThr, method, url, res, threads;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          auth = _ref7.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
            email: email
          }))(_utils.defaultOptionals);
          _endpoints$pendingThr = endpoints.pendingThreads, method = _endpoints$pendingThr.method, url = _endpoints$pendingThr.url;
          _context7.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context7.sent;
          threads = res.result.threads;
          return _context7.abrupt("return", threads.map(function (thread) {
            var messages = thread.messages,
              rest = (0, _objectWithoutProperties2["default"])(thread, _excluded2);
            var messageIds = messages.map(function (item) {
              return item.id;
            });
            var rrbFlag = messages.some(function (message) {
              return message.rrbFlag;
            });
            var ssFlag = messages.some(function (message) {
              return message.ssFlag;
            });
            return _objectSpread(_objectSpread({}, rest), {}, {
              messageIds: messageIds,
              rrbFlag: rrbFlag,
              ssFlag: ssFlag
            });
          }));
        case 8:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _pendingThreads.apply(this, arguments);
}
/**
 * Return the latest recipeints
 *
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<ContactSuggestionsResponse>}
 */
function suggestions(_x12) {
  return _suggestions.apply(this, arguments);
}
function _suggestions() {
  _suggestions = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(_ref8) {
    var auth, optionals, _endpoints$suggestion, method, url, res;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          auth = _ref8.auth;
          optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
          _endpoints$suggestion = endpoints.suggestions, method = _endpoints$suggestion.method, url = _endpoints$suggestion.url;
          _context8.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context8.sent;
          return _context8.abrupt("return", res);
        case 7:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _suggestions.apply(this, arguments);
}
/**
 * Return the interactived attachments for specified contact
 *
 * @public
 * @param {string} contactId - Contact unique ID
 * @param {string}  type - Attachment type
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<ContactAttachmentsResponse>}
 */
function attachments(_x13, _x14) {
  return _attachments.apply(this, arguments);
}
/**
 * Return the interactived attachments by email address
 *
 * @public
 * @param {string} email - Target email address
 * @param {string} type - Attachment type
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<ContactAttachmentsResponse>}
 */
function _attachments() {
  _attachments = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(contactId, _ref9) {
    var auth, type, optionals, _endpoints$attachment, method, url, res;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          auth = _ref9.auth, type = _ref9.type;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
            type: type
          }))(_utils.defaultOptionals);
          _endpoints$attachment = endpoints.attachments, method = _endpoints$attachment.method, url = _endpoints$attachment.url;
          _context9.next = 5;
          return (0, _requests.request)(url(contactId), method, optionals);
        case 5:
          res = _context9.sent;
          return _context9.abrupt("return", res);
        case 7:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _attachments.apply(this, arguments);
}
function attachmentsByEmail(_x15, _x16) {
  return _attachmentsByEmail.apply(this, arguments);
}
/**
 * Upload avatar to contact
 *
 * @public
 * @param {contactId} - Unique contact ID
 * @param {Blob} attachment - The avatar image file to upload
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<APIResponse<string>>}
 */
function _attachmentsByEmail() {
  _attachmentsByEmail = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(email, _ref10) {
    var auth, type, params, optionals, _endpoints$attachment2, method, url, res;
    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          auth = _ref10.auth, type = _ref10.type;
          params = type === 'file' ? {
            type: 'all',
            skip: 'photos'
          } : {
            type: 'photos'
          };
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)(_objectSpread(_objectSpread({}, params), {}, {
            other_email: email,
            timezone: _momentTimezone["default"].tz.guess(),
            page_size: 20
          })))(_utils.defaultOptionals);
          _endpoints$attachment2 = endpoints.attachmentsByEmail, method = _endpoints$attachment2.method, url = _endpoints$attachment2.url;
          _context10.next = 6;
          return (0, _requests.request)(url(), method, optionals);
        case 6:
          res = _context10.sent;
          return _context10.abrupt("return", res);
        case 8:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _attachmentsByEmail.apply(this, arguments);
}
function uploadAvatar(_x17, _x18, _x19) {
  return _uploadAvatar.apply(this, arguments);
}
/**
 * Approve a new sender
 *
 * @public
 * @param {string} email - The email address to approve
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<any>}
 * @throws {RequestError}
 */
function _uploadAvatar() {
  _uploadAvatar = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(contactId, attachment, _ref11) {
    var auth, form, options, _endpoints$uploadAvat, method, url;
    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          auth = _ref11.auth;
          form = new FormData();
          form.append('attachment', attachment);
          options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(form))({});
          _endpoints$uploadAvat = endpoints.uploadAvatar, method = _endpoints$uploadAvat.method, url = _endpoints$uploadAvat.url;
          return _context11.abrupt("return", fetch(url(contactId), _objectSpread({
            method: method
          }, options)).then(function () {
            return "".concat(url(contactId), "?v=").concat((0, _moment["default"])().unix());
          }));
        case 6:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _uploadAvatar.apply(this, arguments);
}
function action(_x20, _x21, _x22) {
  return _action.apply(this, arguments);
}
/**
 * Batch action to approve/block/unblock sender
 *
 * @public
 * @param {[]string} emails - The list of email addresses to apply the action
 * @param {Auth} emails - User validated authentication
 * @returns {Promise<any>}
 * @throws {RequestError}
 */
function _action() {
  _action = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(email, status, rest) {
    return _regenerator["default"].wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          return _context12.abrupt("return", batchAction([email], status, rest));
        case 1:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _action.apply(this, arguments);
}
function batchAction(_x23, _x24, _x25) {
  return _batchAction.apply(this, arguments);
}
function _batchAction() {
  _batchAction = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(emails, status, _ref12) {
    var auth, applyAll, optionals, _endpoints$action, method, url, res;
    return _regenerator["default"].wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          auth = _ref12.auth, applyAll = _ref12.applyAll;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
            emails: emails,
            applyall: applyAll ? 1 : 0
          }))(_utils.defaultOptionals);
          _endpoints$action = endpoints.action, method = _endpoints$action.method, url = _endpoints$action.url;
          _context13.next = 5;
          return (0, _requests.request)(url(status), method, optionals);
        case 5:
          res = _context13.sent;
          return _context13.abrupt("return", res);
        case 7:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return _batchAction.apply(this, arguments);
}
/**
 * List the contacts which are suggested to block
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @return {Promise<SuggestedBlockResponse>}
 */
function fetchSuggestedBlocks(_x26) {
  return _fetchSuggestedBlocks.apply(this, arguments);
}
function _fetchSuggestedBlocks() {
  _fetchSuggestedBlocks = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(_ref13) {
    var auth, optionals, _endpoints$suggestedB, method, url, res;
    return _regenerator["default"].wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          auth = _ref13.auth;
          optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
          _endpoints$suggestedB = endpoints.suggestedBlocks, method = _endpoints$suggestedB.method, url = _endpoints$suggestedB.url;
          _context14.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context14.sent;
          return _context14.abrupt("return", res);
        case 7:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return _fetchSuggestedBlocks.apply(this, arguments);
}
/**
 * Feedback for the backend service which control the suggested block contacts
 *
 * @public
 * @param {string} id - Contact ID
 * @param {number} status - Status for suggested block to feedback
 * @param {Auth} auth - User validated authentication
 * @return {Promise<SuggestedBlockUpdateReponse>}
 */
function updateSuggestedBlock(_x27, _x28) {
  return _updateSuggestedBlock.apply(this, arguments);
}
function _updateSuggestedBlock() {
  _updateSuggestedBlock = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(_ref14, _ref15) {
    var id, status, auth, optionals, _endpoints$suggestedB2, method, url, res;
    return _regenerator["default"].wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          id = _ref14.id, status = _ref14.status;
          auth = _ref15.auth;
          optionals = (0, _functools.compose)((0, _requests.withBody)({
            id: id,
            status: status
          }), (0, _utils.withAuth)(auth))(_utils.defaultOptionals);
          _endpoints$suggestedB2 = endpoints.suggestedBlockAction, method = _endpoints$suggestedB2.method, url = _endpoints$suggestedB2.url;
          _context15.next = 6;
          return (0, _requests.request)(url(), method, optionals);
        case 6:
          res = _context15.sent;
          return _context15.abrupt("return", res);
        case 8:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return _updateSuggestedBlock.apply(this, arguments);
}
/**
 * Returns a pending message IDs mapping
 * by given a batch of email addresses
 *
 * @public
 * @param {string[]} emails - Pending contact emails
 * @param {Auth} auth - User valided authentication
 * @returns {Promise<PendingMessagsResp>}
 */
function pendingMessage(_x29, _x30) {
  return _pendingMessage.apply(this, arguments);
}
function _pendingMessage() {
  _pendingMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16(emails, _ref16) {
    var auth, optionals, _endpoints$pendingMes, url, method, res;
    return _regenerator["default"].wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          auth = _ref16.auth;
          optionals = (0, _utils.withAuth)(auth)({});
          _endpoints$pendingMes = endpoints.pendingMessage, url = _endpoints$pendingMes.url, method = _endpoints$pendingMes.method;
          _context16.next = 5;
          return fetch(url(), {
            method: method,
            body: JSON.stringify(emails),
            headers: _objectSpread(_objectSpread({}, optionals.headers || {}), {}, {
              'Content-Type': 'application/json'
            })
          }).then(function (res) {
            return res.json();
          });
        case 5:
          res = _context16.sent;
          return _context16.abrupt("return", res);
        case 7:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return _pendingMessage.apply(this, arguments);
}
function blockDomain(_x31, _x32) {
  return _blockDomain.apply(this, arguments);
}
function _blockDomain() {
  _blockDomain = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17(auth, params) {
    var optionals, _endpoints$block, method, url, res;
    return _regenerator["default"].wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(params))(_utils.defaultOptionals);
          _endpoints$block = endpoints.block, method = _endpoints$block.method, url = _endpoints$block.url;
          _context17.next = 4;
          return (0, _requests.request)(url(), method, optionals);
        case 4:
          res = _context17.sent;
          return _context17.abrupt("return", res);
        case 6:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return _blockDomain.apply(this, arguments);
}
function unblockDomain(_x33, _x34) {
  return _unblockDomain.apply(this, arguments);
}
function _unblockDomain() {
  _unblockDomain = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18(auth, params) {
    var optionals, _endpoints$unblock, method, url, res;
    return _regenerator["default"].wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(params))(_utils.defaultOptionals);
          _endpoints$unblock = endpoints.unblock, method = _endpoints$unblock.method, url = _endpoints$unblock.url;
          _context18.next = 4;
          return (0, _requests.request)(url(), method, optionals);
        case 4:
          res = _context18.sent;
          return _context18.abrupt("return", res);
        case 6:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return _unblockDomain.apply(this, arguments);
}
//# sourceMappingURL=contacts.js.map